export default __webpack_public_path__ + "static/media/thumbnail_blog_11.4551b7db.png";